import { defineStore } from 'pinia'
import type { CurrentUser } from '@/services/current-user'

interface CurrentUserState {
  user: CurrentUser | null
}

export const useCurrentUserStore = defineStore('current-user', {
  state: (): CurrentUserState => ({
    user: null,
  }),
  actions: {
    setUser(user: CurrentUser | null) {
      this.user = user
    },
    clearUser() {
      this.user = null
    },
  },
  persist: {
    key: 'current-user',
    storage: localStorage
  }
})
